export default __webpack_public_path__ + "static/media/BBQChickenWrap.de7b2b3b.jpg";